<template>
  <div>
    <!-- 篩選 -->
    <div class="card filter-card">
      <div class="card-body">
        <div v-if="!filterVisible" class="filter-toggle-icon" @click="toggleFilter">
          <i class="fa fa-search"></i>
        </div>
        <div v-else>
          <div class="filter-header">
            <button class="btn btn-toggle" @click="toggleFilter"><i class="fa fa-times"></i></button>
          </div>
          <div class="row d-flex ">
            <div class="col-xxl-2 col-6">
              <label for="driver-name">Driver name</label>
              <input type="text" id="driver-name" class="form-control" v-model="filters.driverName" />
            </div>
            <div class="col-xxl-2 col-6 ms-2">
              <label for="driver-id">Driver ID</label>
              <input type="text" id="driver-id" class="form-control" v-model="filters.driverId" />
            </div>
            <div class="col-xxl-2 col-6 ms-2">
              <label for="from-date">From</label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.fromDate" data-language="en" :enable-time-picker="false" placeholder="Select date" />
            </div>
            <div class="col-xxl-2 col-6 ms-2">
              <label for="to-date">To</label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.toDate" data-language="en" :enable-time-picker="false" placeholder="Select date" />
            </div>
            <div class="col-xxl-2 col-12 mt-4 d-flex">
              <button class="btn btn-reset" @click="resetFilters">Reset</button>
              <button class="btn btn-search ms-3" @click="search">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DataTable -->
    <div class="card" v-if="paginatedData != ''">
      <div class="card-body">
        <div class="table-responsive signal-table">
          <table class="table table-hover">
            <thead>
              <tr>
                <th 
                  @click="sortTable('created_at')" 
                  :class="{'sortable': true, 'active': filters.sort_by === 'created_at'}">
                  <span>Created &nbsp;</span>
                  <i v-if="filters.sort_by === 'created_at' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'created_at' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col" class="col-charge-to">Charge to</th>
                <th 
                  @click="sortTable('description')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'description'}">
                  <span>Description &nbsp;</span>
                  <i v-if="filters.sort_by === 'description' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'description' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('amount')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'amount'}">
                  <span>Amount &nbsp;</span>
                  <i v-if="filters.sort_by === 'amount' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'amount' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('paid')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'paid'}">
                  <span>Paid &nbsp;</span>
                  <i v-if="filters.sort_by === 'paid' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'paid' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('paid_by')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'paid_by'}">
                  <span>Paid by &nbsp;</span>
                  <i v-if="filters.sort_by === 'paid_by' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'paid_by' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('payment_date')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'payment_date'}">
                  <span>Payment date &nbsp;</span>
                  <i v-if="filters.sort_by === 'payment_date' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'payment_date' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('settlement_ref')" 
                  :class="{'sortable col-description': true, 'active': filters.sort_by === 'settlement_ref'}">
                  <span>Payment ref &nbsp;</span>
                  <i v-if="filters.sort_by === 'settlement_ref' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'settlement_ref' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col" class="col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paginatedData" :key="index">
                <td>{{ item.created_at }}</td>
                <td>{{ item.charge_to }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.amount }}</td>
                <td>
                  <i :class="item.paid ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                </td>
                <td>{{ item.paid_by }}</td>
                <td>{{ item.payment_date }}</td>
                <td>{{ item.payment_ref }}</td>
                <td>
                 <EditRefund :item="item"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分頁 -->
        <div class="pagination-wrapper">
          <div class="pagination-container">
            <button @click="changePage(1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
            <span>
              Page
                            <input type="number" style="width: 60px;" v-model.number="currentPageInput" @change="changePage(currentPageInput)" />

              of {{ totalPages }}
            </span>
            <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(totalPages)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
          </div>
          <div class="total-count">
            Displaying {{ (currentPage - 1) * itemsPerPage + 1 }} – {{ Math.min(currentPage * itemsPerPage, totalEntries) }} of {{ totalEntries }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-results">No results found.</div>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useFeeAndRefundStore } from '@/store/admin/feeAndRefund'; // 確保這是您的正確 store 路徑
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import EditRefund from './editRefund.vue';

const store = useFeeAndRefundStore();

const filterVisible = ref(false); // 控制查詢器是否顯示

// 表格排序處理邏輯
const sortTable = (field) => {
  if (store.filters.sort_by === field) {
    store.filters.order = store.filters.order === 'asc' ? 'desc' : 'asc';
  } else {
    store.filters.sort_by = field;
    store.filters.order = 'desc';
  }
  store.fetchFeesAndRefunds(store.currentType);
};

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

// 初始化過濾器狀態
const filters = computed(() => store.filters);
const currentPageInput = ref(store.currentPage);  // 初始化當前頁碼輸入框

const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};

const paginatedData = computed(() => store.paginatedData);
const totalPages = computed(() => store.totalPages);
const totalEntries = computed(() => store.totalEntries);
const currentPage = computed(() => store.currentPage);
const itemsPerPage = computed(() => store.itemsPerPage);

const resetFilters = async () => {
  store.filters = {
    type:'refund',
    driverName: '',
    driverId: '',
    fromDate: '',
    toDate: ''
  };
  await store.fetchFeesAndRefunds('refund', 1, itemsPerPage.value, store.filters);  
};

const search = async () => {
  await store.fetchFeesAndRefunds('refund', 1, itemsPerPage.value, filters.value);  
};

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPageInput.value = page;
    store.changePage(page);
  }
};

// 組件掛載時自動加載 refund 資訊
onMounted(() => {
  store.filters.sort_by = 'created_at';
  store.filters.order = 'desc';
  store.currentType = 'refund';
  store.fetchFeesAndRefunds('refund', 1, itemsPerPage.value, filters.value);
  changePage(1);

});
</script>

<style scoped>
/* 你的樣式代碼保持不變 */
.card {
  margin: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 20px;
  position: relative;
}

.no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }

.table-responsive {
  margin-top: 20px;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.col-description {
  min-width: 200px;
}

.table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

/* 排序箭頭樣式 */
.sort-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

/* 排序欄位下的綠色下劃線 */
.table th.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #00c962;
  position: absolute;
  bottom: 0;
  left: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
}

.pagination-container {
  display: flex;
  align-items: center;
}

.pagination-container button {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
}

.pagination-container span {
  margin: 0 10px;
}

.pagination-container input {
  width: 50px;
  text-align: center;
}

.btn-reset {
  /* BTN_B */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 32px;
  gap: 10px;

  width: 150px;
  height: 46px;

  /* Green */
  border: 2px solid #00C962;
  border-radius: 30px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;


}

.btn-search {
  /* BTN_A_V2 */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 32px;
  gap: 10px;

  width: 150px;
  height: 46px;

  /* Green */
  background: #00C962;
  border-radius: 30px;

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;

}

.btn-reset:hover {
    background: white;
    border: 2px solid #00b452;
  }
  .btn-search:hover {
    background: #00b452;
    border: 2px solid #00b452;
  }

.btn-green {
  margin-top: 20px;
  background-color: #00c962;
  height: 40px;
}

.btn-toggle {
  background: none;
  border: none;
  color: #8476f4;
  font-size: 24px;
  cursor: pointer;
}

.filter-toggle-icon {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 24px;
  color: #666;
  cursor: pointer;
}

.total-count {
  font-size: 16px;
  color: #666;
}

.filter-header {
  display: flex;
  justify-content: flex-end;
}

.toggle-filter {
  text-align: right;
  margin: 20px;
}

.signal-table.table-responsive .table tbody tr td:nth-child(n+1) {
  min-width: 140px !important;
}

@media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
